import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_NOTIFIKASI_PATH } from 'app/KinerjaShared/constants/path'

function CardSurveyPendampinganPenilik() {
  return (
    <Card className="py-10 max-w-7xl px-9">
      <section>
        <img
          src="/icon/e-pengelolaan-kinerja-logo.png"
          alt="Pengelolaan Kinerja"
          width={248}
          height={64}
          className="mb-12"
        />

        <Text variant="heading-lg" as="h2" className="mb-4 !text-gray-90">
          Survei Anda membantu Dinas dalam menilai kinerja Penilik
        </Text>

        <div className="space-y-8">
          <Text variant="body-lg" color="subdued">
            Di Pengelolaan Kinerja, Penilik dapat dengan mudah menentukan
            sasaran kinerja yang lebih kontekstual dan spesifik dengan
            pelaksanaan tugasnya. Tim Kinerja dan Pejabat Penilai Kinerja (Dinas
            Pendidikan) kemudian akan menilai kinerja Penilik.
            <br />
            <br />
            Dengan mengisi survei, Anda turut membantu Dinas dalam menilai
            Pemantauan, Penilaian, dan Pembinaan yang dilakukan oleh Penilik di
            satuan pendidikan Anda. Sudah siap isi survei?
          </Text>
        </div>

        <Link href={PENGELOLAAN_KINERJA_NOTIFIKASI_PATH} passHref>
          <Button
            as="a"
            type={undefined}
            color="blue"
            size="lg"
            fullWidth
            className="mt-10"
          >
            Cek notifikasi untuk isi survei
          </Button>
        </Link>
      </section>
    </Card>
  )
}

export default CardSurveyPendampinganPenilik
